import LOCALIZE from "@src/locales/languages.json";

type Lang = {
  lang: string,
  localize: object
}

export const currentLanguage = (state = {}, action: any) => {
  let localize = {};

  if (LOCALIZE[action.lang]) {
    localize = LOCALIZE[action.lang]
    localize["LABEL.ORDER_PROCESS.AUDITS"] = "Audits"
    localize["LABEL.ORDER_PROCESS.LOCATION"] = "Location"
    localize["LABEL.ORDER_PROCESS.SCAN_TYPE"] = "Scan type"
    localize["LABEL.ORDER_PROCESS.CONNECTED_ORDERS"] = "Connected orders"
    localize["LABEL.ORDER_PROCESS.CONNECTED_ORDERS_NUMBER"] = `{total} connected orders`
    localize["LABEL.SELF_REPORTED"] = `Self-reported`
    localize["LABEL.ORDER_PROCESS.NO_CONNECTED_ORDERS"] = `This process has no connected orders`
    localize["LABEL.ORDER_PROCESS.SOME_MORE"] = `{total} more`
    localize["LABEL.ORDER_PROCESS.PRODUCT_MATERIALS"] = `Product materials`

    localize["LABEL.ORDER_PROCESS.PRODUCT_MATERIALS"] = `Product materials`
    localize["LABEL.ORDER_PROCESS.PRODUCT_MATERIALS"] = `Product materials`
    localize["LABEL.ORDER_PROCESS.PRODUCT_MATERIALS"] = `Product materials`
    localize["LABEL.ORDER_PROCESS.PRODUCT_MATERIALS"] = `Product materials`

    localize["LABEL.B2C.DETAIL_VIEW.FULL_JOURNEY"] = "Full product journey"
    localize["LABEL.B2C.DETAIL_VIEW.HEADER.PROCESS"] = "Process"
    localize["LABEL.B2C.DETAIL_VIEW.HEADER.DATE_TIME"] = "Date & Time"
    localize["LABEL.B2C.DETAIL_VIEW.HEADER.MANUFACTURER"] = "Manufacturer"
    localize["LABEL.B2C.DETAIL_VIEW.HEADER.COUNTRY"] = "Country"
    localize["LABEL.B2C.DETAIL_VIEW.HEADER.LOCATION"] = "Location"

    localize["B2C.VERIFY.MAPPED"] = "Mapped"
    localize["B2C.VERIFY.SELF_REPORTED"] = "Self-reported"

    localize["FIP.ERROR.PAGE_NOT_FOUND"] = "404 - Page not found"
    localize["FIP.COMMON.HOME"] = "Home"

    localize["LABEL.B2C.VERIFICATION_LEGEND.STATUS.SELF_REPORTED.DESCRIPTION"] = "This audit has been self-reported by the company and has not been independently verified or authenticated by FibreTrace. FibreTrace assumes no liability for the accuracy of claims made by the company or other parties relying on self-reported audits."
    localize["LABEL.B2C.VERIFICATION_LEGEND.STATUS.VERIFIED.DESCRIPTION"] = "This audit has been independently verified by FibreTrace using patented pigment and scanner technology, ensuring full traceability and authenticity."
    localize["LABEL.B2C.VERIFICATION_LEGEND.STATUS.CLAIMED.DESCRIPTION"] = "This audit has been verified by the company or a third party as indicated. However, FibreTrace has not independently verified this audit using its patented pigment and scanner technology."

    localize["LABEL.VERIFIED_BY_FIBRETRACE.SCANNER"] = "Verified with scanner ID {0}";
    localize["B2C.VERIFY.CLAIMED"] = "Claimed";

  }

  switch (action.type) {
    case 'ADD_CURRENT_LANG':
      return {
        localize: {
          ...localize,
          ...action.defaultLang,
          ...action.currentLang
        },
        lang: action.lang
      }
    default:
      return state
  }
}
